var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-tour',{attrs:{"name":_vm.name,"steps":_vm.role_steps,"options":_vm.default_options}}),_c('v-overlay',{attrs:{"value":_vm.show_overlay,"z-index":"0"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }